import { z } from 'zod';
import { getMutationSchema } from '../../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useSingleResourceSingleParentedResourceAdapterActions } from '../../../../resource-base/adapters/useSingleResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../../resource-base/artifactResourceTypes';

export enum GridElementDecoratorPropertyValidation {
    TEXT_COLOR = 'TEXT_COLOR',
    BACKGROUND_COLOR = 'BACKGROUND_COLOR',
}

export const GridElementDecoratorResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.GRID_ELEMENT_DECORATOR).default(ResourceType.GRID_ELEMENT_DECORATOR),
    textColor: z.string().nullable(),
    backgroundColor: z.string().nullable(),
});
export const GridElementDecoratorMutationResourceSchema = getMutationSchema(GridElementDecoratorResourceSchema);

export type GridElementDecoratorResource = z.infer<typeof GridElementDecoratorResourceSchema>;

export const defaultGridElementDecoratorResource: GridElementDecoratorResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.GRID_ELEMENT_DECORATOR,
    textColor: null,
    backgroundColor: null,
};

export function useGridElementDecoratorActions() {
    return {
        ...useSingleResourceSingleParentedResourceAdapterActions(
            'project/grid-element-decorator',
            ResourceType.GRID_ELEMENT_DECORATOR,
            GridElementDecoratorResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/grid-element-decorator',
            ResourceType.GRID_ELEMENT_DECORATOR,
            GridElementDecoratorResourceSchema
        ),
    };
}
